import { prompt, type PromptDefinition } from './models';

export const BUILDING_SUPERINTENDENT_PROMPTS = [
    prompt(
        'Keep it running',
        'What day-to-day issues need follow-up in this building?',
        'Which buildings have unresolved day-to-day issues needing site attention?'
    ),
    prompt(
        'Coordinate people',
        'Which site visits and contractor tasks are recorded for this building?',
        'Which buildings need coordination of upcoming site visits or contractor tasks?'
    ),
    prompt(
        'Manage risk',
        'What site access and emergency instructions apply to this building?',
        'Which buildings have incomplete site access or emergency instructions?'
    ),
    prompt(
        'Keep it running',
        'Find site handover notes for this building about…',
        'Find site handover notes across my buildings about…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'What faults were recorded on recent rounds of this building?',
        'Which buildings have faults from site rounds still awaiting follow-up?'
    ),
    prompt(
        'Coordinate people',
        "Who should receive escalations about this building's on-site issues?",
        'Which buildings have unclear contacts for escalating on-site issues?'
    ),
    prompt(
        'Manage risk',
        'What equipment shutdowns or access restrictions are recorded for this building?',
        'Which buildings have shutdowns or access restrictions affecting site attendance?'
    ),
    prompt(
        'Keep it running',
        'Find site inspection notes for this building involving…',
        'Find site inspection notes across my buildings involving…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'Which contractor visits to this building lack a service or completion note?',
        'Which buildings have contractor visits without completion records?'
    ),
    prompt(
        'Understand it',
        'What common-area issues are recorded for this building?',
        'Which buildings have recurring common-area issues to raise with management?'
    ),
    prompt(
        'Understand it',
        'What should I include in the next site handover for this building?',
        'Compare open site-handover matters across my buildings.'
    ),
    prompt(
        'Keep it running',
        'Prepare a site handover draft for this building covering…',
        'Prepare a site-visit priorities list across my buildings covering…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
